module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAfCAYAAAAMeVbNAAAA0ElEQVRIx2NgAILs/GJXsnBxsTwDPpCZV5gIxP+BeDdJOL/oMpB+hdeCrLyieqArGhlIBEA9VUC924H4AU4LKDE8O6+oLbugKBunBZQaDmbjsoAahuO0gFqGwyzIzC98CLeAogjNLzyWU1DihIyzCgonZOUXvfj//z8j2YZnFRXJAvXeBOJ9WPD73KKSPLINx2txfnFFVkFRJ80MB2ayjlHDRw0fNXzU8FHDRw0fBIaDauycglJramFgq6AdbHhmYYUS0ILnQHyUivhpVkGZJgDeqYLxCwpPAgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./resources/images/document_2x.png
// module id = 975
// module chunks = 0